import emailAnalysisQueryKeys from '@/features/analysis/queries/queryKeys';
import crmQueryKeys from '@/features/crm/queries/queryKeys';
import notesQueryKeys from '@/features/notes/queries/queryKeys';
import onesuranceQueryKeys from '@/features/onesurance/queries/queryKeys';
import partyQueryKeys from '@/features/party/queries/queryKeys';
import policiesQueryKeys from '@/features/policies/queries/queryKeys';
import riskObjectsQueryKeys from '@/features/risk-objects/queries/queryKeys';

const queryKeys = {
  party: partyQueryKeys,
  riskObjects: riskObjectsQueryKeys,
  policies: policiesQueryKeys.policies,
  policyPackages: policiesQueryKeys.policyPackages,
  notes: notesQueryKeys,
  emailAnalysis: emailAnalysisQueryKeys,
  crm: crmQueryKeys,
  onesurance: onesuranceQueryKeys,
  me: () => ['me'] as const,
  brokers: {
    all: () => ['brokers'] as const,
    details: () => [...queryKeys.brokers.all(), 'details'] as const,
    detail: (id: string) => [...queryKeys.brokers.details(), id] as const,
    me: () => [...queryKeys.brokers.detail('me')] as const,

    integrations: (id: string) =>
      [...queryKeys.brokers.detail(id), 'integrations'] as const,
  },
  distributions: {
    all: () => ['distributions'] as const,

    details: () => [...queryKeys.distributions.all(), 'details'] as const,
    detail: (id: string) => [...queryKeys.distributions.details(), id],

    connections: (id: string) =>
      [...queryKeys.distributions.detail(id), 'connections'] as const,
  },
  singularity: {
    job: (id: string) => ['singularity', 'job', id] as const,
  },
  advisoryReports: {
    all: () => ['advisory-reports'] as const,

    lists: () => [...queryKeys.advisoryReports.all(), 'list'] as const,
    details: () => [...queryKeys.advisoryReports.all(), 'detail'] as const,

    list: (filter: unknown) =>
      [...queryKeys.advisoryReports.lists(), filter] as const,

    detail: (id: string) =>
      [...queryKeys.advisoryReports.details(), id] as const,
  },
  conversations: {
    all: () => ['conversations'] as const,

    lists: () => [...queryKeys.conversations.all(), 'list'] as const,
    details: () => [...queryKeys.conversations.all(), 'detail'] as const,

    list: (filter: unknown) =>
      [...queryKeys.conversations.lists(), filter] as const,
  },
  customers: {
    all: (partyId: string) => ['customers', partyId] as const,

    lists: (partyId: string) =>
      [...queryKeys.customers.all(partyId), 'list'] as const,
    details: (partyId: string) =>
      [...queryKeys.customers.all(partyId), 'detail'] as const,

    list: (partyId: string, filter: unknown) =>
      [...queryKeys.customers.lists(partyId), filter] as const,
  },
};

export default queryKeys;
